define([
	"csi/def/Action",
	"csi/def/ActionFactory"
], function(Action, ActionFactory) {

	return ActionFactory.declare("Popup", Action, {
		constructor: function(obj) {
			// set defaults for action if not explicitly configured		
			this.m_tag = this.m_tag || "Popup";
		}
	});
});